<template>
  <div class="company-select-title">
    <TextOverTooltip
      :content="userInfo.tenantName || '--'"
      placement="right"
    />
  </div>
</template>

<script setup>
import { useStoreGetters } from '@/store/hooks'

const { userInfo } = useStoreGetters(['userInfo'])
</script>

<style lang="scss" scoped>
.company-select-title {
  background: #f3f3f4;
  padding: 5px 10px;
  width: 206px;
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.9);
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
}
</style>
